import { render, staticRenderFns } from "./MaresSuggestion.vue?vue&type=template&id=6095f93f&"
import script from "./MaresSuggestion.vue?vue&type=script&lang=js&"
export * from "./MaresSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports